import { Result } from "../../feedback/result/Result";

const PageUnauthorised = () => <Result status="403" title="403" />;

export { PageUnauthorised };
